import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import * as pages from '../pages'

const SwitchWithRoutes = ({ routes }) => (
  <Switch>
    {routes.map(route => (
      <Route
        key={route.pattern}
        path={route.pattern}
        exact={route.exactly}
        strict={route.strict}
        render={props => (<route.component {...props} routes={route.routes} />)}
      />
    ))}
    <Route key="not-found-page" component={pages.NotFoundPage} />
  </Switch>
)

SwitchWithRoutes.defaultProps = {
  resourceNotFound: false,
}
SwitchWithRoutes.propTypes = {
  routes: PropTypes.array.isRequired,
}

export default SwitchWithRoutes



// WEBPACK FOOTER //
// ./src/browser/components/SwitchWithRoutes.js